import { NgModule } from '@angular/core';
import { OrderbyPipe } from './orderby/orderby';
import { FilterByFavoriteFolderPipe } from './filter-by-favorite-folder/filter-by-favorite-folder';
import { FilterByIndicationPipe } from './filter-by-indication/filter-by-indication';
import { OrderbyKeywordPipe } from './orderby-keyword/orderby-keyword';
import { FilterAssetsByPackagePipe } from './filter-assets-by-package/filter-assets-by-package';
@NgModule({
	declarations: [OrderbyPipe,
    FilterByFavoriteFolderPipe,
    FilterByIndicationPipe,
    OrderbyKeywordPipe,
    FilterAssetsByPackagePipe],
	imports: [],
	exports: [OrderbyPipe,
    FilterByFavoriteFolderPipe,
    FilterByIndicationPipe,
    OrderbyKeywordPipe,
    FilterAssetsByPackagePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts